import find from 'lodash/find';

export const getPrimaryDescriptionFieldConfig = ({ isShowButtonCol, orderReviewHandleableConfig, identifier }) => {
  const itemObj = find(orderReviewHandleableConfig, { identifier });
  const editableFlag = itemObj && itemObj.editable;
  const deletableFlag = itemObj && itemObj.deletable;
  return {
    isShowEditButton: editableFlag,
    isShowDelButton: deletableFlag,
    labelSpanConfig: {
      span: 8,
      spanMd: isShowButtonCol ? 7 : 9,
    },
    valueSpanConfig: {
      span: isShowButtonCol ? 8 : 4,
      spanMd: 3,
    },
    btnColSpanConfig: {
      span: 4,
      spanMd: 2,
    },
  };
};

export const getSecondaryDescriptionFieldConfig = ({ isShowButtonCol }) => {
  return {
    labelSpanConfig: {
      span: 12,
      spanMd: isShowButtonCol ? 7 : 9,
    },
    justLabel: true,
  };
};

export const getSubDescriptionFieldConfig = ({ isShowButtonCol }) => {
  return getSecondaryDescriptionFieldConfig({ isShowButtonCol });
};

export const getDiscountFieldConfig = ({ isShowButtonCol }) => {
  return {
    labelSpanConfig: {
      span: 8,
      spanMd: isShowButtonCol ? 7 : 9,
    },
    valueSpanConfig: {
      span: 4,
      spanMd: 3,
    },
  };
};

const getOrderLineTitleConfig = ({ isShowButtonCol }) => {
  return {
    labelColTitleSpanConfig: {
      span: 8,
      spanMd: isShowButtonCol ? 7 : 9,
    },
    valueColTitleSpanConfig: {
      span: 4,
      spanMd: 3,
    },
  };
};

const getOrderLineFieldsConfig = ({
  orderReviewHandleableConfig,
  identifier,
  isShowButtonCol,
}) => {
  return {
    primaryDescriptionFieldConfig: getPrimaryDescriptionFieldConfig({
      orderReviewHandleableConfig,
      identifier,
      isShowButtonCol,
    }),
    secondaryDescriptionFieldConfig: getSecondaryDescriptionFieldConfig({ isShowButtonCol }),
    subDescriptionFieldConfig: getSubDescriptionFieldConfig({ isShowButtonCol }),
    discountFieldConfig: getDiscountFieldConfig({ isShowButtonCol }),
    orderLineTitleConfig: getOrderLineTitleConfig({ isShowButtonCol }),
  };
};

// This default config is for orderReview section,
// confirmation->orderDetail, makePayment orderDetail(mobile&tablet view)
export default getOrderLineFieldsConfig;
